<template>
  <div class="bg-white">
    <div class="d-flex justify-content-end h-100 align-items-center">
      <b-button size="sm" variant="outline-secondary" :class="['coverage-control-btn',{'disabled':!back}]" :disabled="!back" @click="$emit('back')">
        {{ $t('Back') }}
      </b-button>
      <b-button size="sm" variant="secondary" :class="['coverage-control-btn',{'disabled': disableNext}]" :disabled="disableNext" @click="$emit('next')">
        {{ $t('Next') }}
      </b-button>
      <div class="d-inline-flex coverage-control-btn text-center mr-2">
        <b-button
          size="sm"
          variant="primary"
          :class="['animated-submit', submitClassObject, {'disabled': disableSave, 'animate': animateSubmitButton}]"
          :disabled="disableSave"
          @click="coverageSaveEvent"
        >
          <span
            v-b-tooltip.hover
            class="d-flex justify-content-center w-100 stretched-link"
            :title="disableSave ? $t('You have no changes in this page to save'): ''"
          >{{ $t('Save') }}</span>
        </b-button>
      </div>
      <b-button
        v-if="secondaryButtonText"
        size="sm"
        :disabled="disableBasket"
        class="last coverage-control-btn"
        variant="outline-primary"
        @click="$emit('secondary-button-click')"
      >
        {{ secondaryButtonText }}
      </b-button>
    </div>
  </div>
</template>

<script>
import submitAnimationHandler from "@/imports/mixins/submitAnimationHandler";

export default {
  name: "CoverageButtons",
  mixins: [submitAnimationHandler],
  props: [
    'disableSave',
    'disableNext',
    'busy',
    'next',
    'back',
    'secondaryButtonText',
    'disableBasket',
    'savingAnimation',
  ],
  methods: {
    coverageSaveEvent: function() {
      this.$emit('save');
      this.animateSubmitButton = this.savingAnimation;
      this.enableSubmitAnimation(true);
    }
  }
}
</script>

<style scoped lang="scss">
@include media-breakpoint-between(md, lg) {
  .coverage-control-btn {
    width: 100px;
    margin-left: 10px;
    .animated-submit {
      width: 100%;
    }
  }
}
</style>
